import React, { useState } from 'react'
import IntlMessages from '@crema/utility/IntlMessages'
import Box from '@material-ui/core/Box'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { selectOfferingCategoryStatus } from 'store/reducers/temple/offeringCategorySlice'
import FitContentPaper from 'components/Paper/FitContentPaper'
import FormOfferingCategory from './FormOfferingPool'
import { FormikHelpers } from 'formik'
import { unwrapResult } from '@reduxjs/toolkit'
import { getFieldErrors } from 'utils/api'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import useRestricter from 'hooks/useRestricter'
import { offeringPoolCreateThunk, OfferingPoolRequestType, OfferingPoolResponseType } from 'store/reducers/temple/offeringPoolSlice'
type Props = {
    onClose?:() => void
    onCreated?: (pool: OfferingPoolResponseType) => void
}


const AddOfferingPool:React.FC<Props> = ({onClose, onCreated}) => {
    const api = useAppSelector(selectOfferingCategoryStatus)
    const dispatch = useAppDispatch()
    const [addedItem, setAddedItem] = useState<OfferingPoolResponseType | null>(null)
    const hasAddPermission = useRestricter(PERMISSIONS.ADD, RESTRICTED_PATHS.OFFERING_CATEGORIES)

    const handleSubmit = (data: OfferingPoolRequestType, actions: FormikHelpers<OfferingPoolRequestType>) => {
        setAddedItem(null)
        dispatch(offeringPoolCreateThunk({poolName:data.poolName,poolLimit:data.poolLimit!=='' ? data.poolLimit : undefined
        }))
            .then(unwrapResult)
            .then(response => {
                if (response && !Array.isArray(response)) {
                    setAddedItem(response)
                    onCreated?.(response)
                }
                actions.resetForm()
                if(onClose) onClose()
            })
            .catch(err => {
                Object.entries(getFieldErrors(data, err)).forEach(([key, value]) =>
                    actions.setFieldError(key, value))
            })
            .finally(() => {
                actions.setSubmitting(false)
            })
    }
    const handleSuccess = () => addedItem ? `Offering Pool ${addedItem.poolName} Successfully added` : ''

    if (!hasAddPermission) return null

    return (
            <FitContentPaper style={{height:'fit-content'}}>
                <Box component="h5" mb={4}><IntlMessages id="offeringPool.add" /></Box>
                <FormOfferingCategory
                    buttonLabelId="common.create"
                    api={api}
                    initialValues={{ poolLimit: '', poolName: '' }}
                    onSubmitCb={handleSubmit}
                    isSuccess={Boolean(addedItem)}
                    successCb={handleSuccess}
                />
            </FitContentPaper>
    )
}

export default AddOfferingPool
